function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.261 129H6.97599C3.12937 129 0 125.874 0 122.032V15.0588C0 11.2167 3.12937 8.09106 6.97599 8.09106H27.5739C29.3249 8.09106 30.7448 9.50899 30.7448 11.2582V14.8466C30.7448 15.1959 31.0292 15.48 31.379 15.48H58.858C59.2078 15.48 59.4922 15.1959 59.4922 14.8466V11.2582C59.4922 9.50899 60.9121 8.09106 62.6631 8.09106H83.261C87.1076 8.09106 90.237 11.2167 90.237 15.0588V122.032C90.237 125.874 87.1076 129 83.261 129ZM6.97599 14.4253C6.62624 14.4253 6.34181 14.7094 6.34181 15.0588V122.032C6.34181 122.381 6.62624 122.666 6.97599 122.666H83.261C83.6108 122.666 83.8952 122.381 83.8952 122.032V15.0588C83.8952 14.7094 83.6108 14.4253 83.261 14.4253H65.834V14.8466C65.834 18.6886 62.7047 21.8143 58.858 21.8143H31.379C27.5323 21.8143 24.403 18.6886 24.403 14.8466V14.4253H6.97599V14.4253Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.0661 15.0586V122.032C87.0661 124.129 85.3636 125.833 83.261 125.833H6.97599C4.87653 125.833 3.1709 124.129 3.1709 122.032V15.0586C3.1709 12.9588 4.87653 11.2581 6.97599 11.2581H27.5739V14.8464C27.5739 16.9462 29.2763 18.647 31.379 18.647H58.858C60.9607 18.647 62.6631 16.9462 62.6631 14.8464V11.2581H83.261C85.3636 11.2581 87.0661 12.9588 87.0661 15.0586Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.2291 56.6946C54.4759 56.6946 53.7551 56.4021 53.2322 55.8844L47.7334 50.4395C46.6697 49.3862 46.7016 47.7092 47.8047 46.6934C48.9078 45.6777 50.6639 45.7081 51.7276 46.7612L55.2297 50.2289L67.6197 37.9626C68.6833 36.9095 70.4398 36.8793 71.5426 37.8951C72.6454 38.9108 72.677 40.5881 71.6133 41.6412L57.2264 55.8847C56.7031 56.4021 55.9824 56.6946 55.2291 56.6946Z",
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.1873 73.4537C18.3533 73.4537 17.5352 73.1148 16.9454 72.5257C16.356 71.9366 16.0195 71.1195 16.0195 70.2865C16.0195 69.4504 16.356 68.6333 16.9454 68.0474C17.5384 67.4551 18.3533 67.1194 19.1873 67.1194C20.0244 67.1194 20.8393 67.4551 21.4323 68.0474C22.0221 68.6364 22.3582 69.4504 22.3582 70.2865C22.3582 71.1195 22.0221 71.9366 21.4323 72.5257C20.8422 73.1148 20.0241 73.4537 19.1873 73.4537Z",
  fill: "#6F62FF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.2236 73.4537C27.3897 73.4537 26.5748 73.1148 25.9818 72.5257C25.3923 71.9334 25.0527 71.1195 25.0527 70.2865C25.0527 69.4504 25.392 68.6364 25.9818 68.0442C26.5716 67.4551 27.3897 67.1194 28.2236 67.1194C29.0608 67.1194 29.8757 67.4551 30.4655 68.0442C31.0584 68.6364 31.3974 69.4504 31.3974 70.2865C31.3974 71.1195 31.0584 71.9334 30.4655 72.5257C29.8757 73.1148 29.0604 73.4537 28.2236 73.4537Z",
  fill: "#6F62FF"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.4796 85.4645H19.1885C17.4375 85.4645 16.0176 84.0466 16.0176 82.2974C16.0176 77.9923 19.524 74.4897 23.8332 74.4897C28.1438 74.4897 31.6501 77.9923 31.6501 82.2974C31.6505 84.0466 30.2308 85.4645 28.4796 85.4645Z",
  fill: "#6F62FF"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.7236 43.5909C17.8897 43.5909 17.0748 43.252 16.4818 42.6629C15.8923 42.0738 15.5527 41.2567 15.5527 40.4237C15.5527 39.5908 15.892 38.7737 16.4818 38.1846C17.0748 37.5955 17.8897 37.2566 18.7236 37.2566C19.5576 37.2566 20.3757 37.5955 20.9655 38.1846C21.5549 38.7737 21.8945 39.5908 21.8945 40.4237C21.8945 41.2567 21.5553 42.0738 20.9655 42.6629C20.3757 43.252 19.5576 43.5909 18.7236 43.5909Z",
  fill: "#6F62FF"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.7607 43.5909C26.9268 43.5909 26.1087 43.252 25.5189 42.6629C24.9295 42.0738 24.5898 41.2599 24.5898 40.4237C24.5898 39.5908 24.9291 38.7737 25.5189 38.1846C26.1087 37.5955 26.9268 37.2566 27.7607 37.2566C28.5979 37.2566 29.4128 37.5955 30.0026 38.1846C30.5955 38.7737 30.9317 39.5908 30.9317 40.4237C30.9317 41.2599 30.5955 42.0738 30.0026 42.6629C29.4128 43.252 28.5976 43.5909 27.7607 43.5909Z",
  fill: "#6F62FF"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.8344 56.6873C19.663 56.6873 16.2695 53.2978 16.2695 49.1317C16.2695 47.3825 17.6895 45.9646 19.4404 45.9646H28.228C29.9789 45.9646 31.3989 47.3825 31.3989 49.1317C31.3986 53.2978 28.0054 56.6873 23.8344 56.6873Z",
  fill: "#6F62FF"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.082 103.238C29.2481 103.238 28.43 102.899 27.8402 102.31C27.2504 101.721 26.9111 100.903 26.9111 100.07C26.9111 99.2375 27.2501 98.4204 27.8402 97.8313C28.43 97.2422 29.2481 96.9033 30.082 96.9033C30.916 96.9033 31.7341 97.2422 32.3236 97.8313C32.9165 98.4204 33.2529 99.2375 33.2529 100.07C33.2529 100.903 32.9165 101.721 32.3236 102.31C31.7341 102.899 30.916 103.238 30.082 103.238Z",
  fill: "#444B54"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.8584 21.8143H31.3793C27.5327 21.8143 24.4033 18.6886 24.4033 14.8466V7.66668C24.4033 3.82463 27.5327 0.698975 31.3793 0.698975H58.8584C62.705 0.698975 65.8344 3.82463 65.8344 7.66668V14.8466C65.8344 18.6886 62.705 21.8143 58.8584 21.8143ZM31.3793 7.03326C31.0296 7.03326 30.7451 7.31735 30.7451 7.66668V14.8466C30.7451 15.1959 31.0296 15.48 31.3793 15.48H58.8584C59.2081 15.48 59.4926 15.1959 59.4926 14.8466V7.66668C59.4926 7.31735 59.2081 7.03326 58.8584 7.03326H31.3793Z",
  fill: "#6F62FF"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.082 103.238C29.2481 103.238 28.43 102.899 27.8402 102.31C27.2504 101.721 26.9111 100.903 26.9111 100.07C26.9111 99.2375 27.2501 98.4204 27.8402 97.8313C28.43 97.2422 29.2481 96.9033 30.082 96.9033C30.916 96.9033 31.7341 97.2422 32.3236 97.8313C32.9165 98.4204 33.2529 99.2375 33.2529 100.07C33.2529 100.903 32.9165 101.721 32.3236 102.31C31.7341 102.899 30.916 103.238 30.082 103.238Z",
  fill: "#6F62FF"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.5405 102.568C18.7753 102.568 18.0278 102.257 17.4837 101.716C16.9425 101.173 16.6309 100.426 16.6309 99.6618C16.6309 98.8946 16.9422 98.1477 17.4837 97.6042C18.0278 97.0637 18.7753 96.7556 19.5405 96.7556C20.3089 96.7556 21.0564 97.0637 21.6005 97.6042C22.1417 98.1448 22.4502 98.8946 22.4502 99.6618C22.4502 100.426 22.1417 101.173 21.6005 101.716C21.0564 102.257 20.3057 102.568 19.5405 102.568Z",
  fill: "#6F62FF"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 16.8018,
  y: 105.405,
  width: 15.6522,
  height: 4.8855,
  rx: 2.44275,
  fill: "#6F62FF"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M62.6635 7.66678V14.8467C62.6635 16.9465 60.961 18.6473 58.8584 18.6473H31.3793C29.2767 18.6473 27.5742 16.9465 27.5742 14.8467V7.66678C27.5742 5.57013 29.2767 3.86621 31.3793 3.86621H58.8584C60.961 3.86621 62.6635 5.57013 62.6635 7.66678Z",
  fill: "white"
});

var SvgSurvey = function SvgSurvey(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 91,
    height: 129,
    viewBox: "0 0 91 129",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurvey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/survey.cf3dacbe.svg";
export { ForwardRef as ReactComponent };